/* eslint-disable import/prefer-default-export */
import CountryISO from '@mohammad231/iso_3166-1';
import {
  CredentialSubjectDate,
  EmailCredentialSubject,
  IDDocumentCredentialSubject,
  VerifiableCredential,
} from '../common/types';

export const emailAddressFromCredential = (credential: VerifiableCredential): string => {
  // Extract the necessary components
  const email = credential.credentialSubject as EmailCredentialSubject;
  const { username } = email.contact.email;
  const domainName = email.contact.email.domain.name;
  const domainTld = email.contact.email.domain.tld;

  // Construct the email address
  const emailAddress = `${username}@${domainName}.${domainTld}`;

  return emailAddress;
};

export const dateStringFromExpiry = (expiry: CredentialSubjectDate): string => {
  const date = new Date(expiry.year, expiry.month - 1, expiry.day);
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
};

export const documentTitleFromSubject = (
  subject: IDDocumentCredentialSubject,
  transactionFn: (_str: string) => string,
): string => {
  const countryCode = CountryISO.get({
    alpha_3: subject.document.issueCountry, // ISO 3166-1 Alpha-3
  });
  const alpha2 = Array.isArray(countryCode) ? countryCode[0].alpha_2 : countryCode?.alpha_2;

  return `${transactionFn(`countries.country_${alpha2}`)} - ${transactionFn(
    `screens.documentPass.preparation.documentTypes.${subject.document.type}`,
  )}`;
};
export type DocumentDisplayAttributes = { title: string; expiry: string };
export const documentAttributesFromCredential = (
  credential: VerifiableCredential,
  transactionFn: (_str: string) => string,
): DocumentDisplayAttributes => {
  const credentialSubject = credential.credentialSubject as IDDocumentCredentialSubject;
  return {
    title: documentTitleFromSubject(credentialSubject, transactionFn),
    expiry: credentialSubject.document.dateOfExpiry
      ? dateStringFromExpiry(credentialSubject.document.dateOfExpiry)
      : '',
  };
};
